// Ordered steps for the skin-analysis capture wizard.
//
// `lighting` gates on a brightness heuristic and, once passed, records a forward
// baseline pose. Every `pose` step then tests the head pose RELATIVE to that
// baseline (deltas), so it adapts to each user's face geometry. When a step's
// test holds for HOLD_MS the wizard silently captures a frame and advances.
//
// Thresholds are deliberately gentle and may want per-device tuning.
export const HOLD_MS = 600;
export const MIN_BRIGHTNESS = 85; // mean luma 0–255 over the frame

// Face-box width as a fraction of the frame width — used for distance guidance.
export const FACE_MIN_RATIO = 0.22; // below this the user is too far away
export const FACE_MAX_RATIO = 0.55; // above this the user is too close

export const WIZARD_STEPS = [
  {
    id: 'setup',
    kind: 'setup',
    instruction: 'Get into position',
    hint: 'Face the camera in good, even light.',
  },
  {
    id: 'left',
    kind: 'pose',
    instruction: 'Slowly turn your head to your LEFT',
    test: (d) => d.dyaw > 0.12,
  },
  {
    id: 'right',
    kind: 'pose',
    instruction: 'Now turn your head to your RIGHT',
    test: (d) => d.dyaw < -0.12,
  },
  {
    id: 'forward',
    kind: 'pose',
    instruction: 'Look straight ahead, like taking a photo',
    // Loosened so returning to center after a turn reliably registers.
    test: (d) => Math.abs(d.dyaw) < 0.1 && Math.abs(d.dpitch) < 0.13,
    final: true, // its capture is the one we annotate with hotspots
  },
];
